function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18.688,3.375H11.506A2.4,2.4,0,0,0,9.072,5.749V6.26H8.621A2.4,2.4,0,0,0,6.188,8.633V25.941a2.455,2.455,0,0,0,2.434,2.434h12.5A2.4,2.4,0,0,0,23.5,25.941V25.49h.511a2.4,2.4,0,0,0,2.374-2.434V11.067Zm0,2.68L23.7,11.067H18.688Zm2.885,19.886a.485.485,0,0,1-.451.511H8.621a.535.535,0,0,1-.511-.511V8.633a.485.485,0,0,1,.511-.451h.451V23.537a1.706,1.706,0,0,0,1.953,1.953H21.572Zm2.885-2.885a.485.485,0,0,1-.451.511h-12.5A.535.535,0,0,1,11,23.056V5.749a.485.485,0,0,1,.511-.451h5.258V12.99h7.692Z",
  transform: "translate(-6.188 -3.375)"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.192,
    height: 25,
    viewBox: "0 0 20.192 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.450fef25.svg";
export { ForwardRef as ReactComponent };